export const personal = {
  namePlain: "Riley",
  nameItalic: "Thomas",
  tagline:
    "Building systems that are quiet and precise — the way good infrastructure should be.",
  location: "Toronto, ON",
  focus: "Full-Stack Development, APIs",
  available: true,
  links: {
    github: "https://github.com/theLegasea",
    linkedin: "https://www.linkedin.com/in/the-ol-riler/",
    /*     resume: "/userdata/RT_Resume.pdf",
     */ email: "rileythomas.elevate@gmail.com",
    /*     cv: "/userdata/ElectricMind_cv.pdf",
     */
  },
};

export const about =
  "Complexity is easy, but clarity is a choice. I’m interested in the points of contact—where data meets" +
  " design and where logic meets the real world." +
  " I aim for the kind of engineering that feels inevitable: silent, efficient, and fundamentally sound.";

// "There is a specific kind of satisfaction in a system that hums. I focus on the invisible craftsmanship: the clean handoff," +
// " the robust edge case, and the architecture that stays out of your way." +
// " I believe software should be as dependable as a physical tool."

export const skills = [
  "TypeScript",
  "JavaScript",
  "React",
  "Node.js",
  "MongoDB",
];

export const secondarySkills = [
  "Spring Boot",
  "ASP.NET Core",
  "GraphQL",
  "REST APIs",
  "PostgreSQL",
  "Python",
  "Java",
  "C#",
  "ETL Pipelines",
  "SDLC",
  "Agile Methodologies",
  "Mobile Development",
  "SwiftUI",
  "Docker",
  "Git",
  "PowerBI",
];

export const education = [
  {
    years: "2023 – 2026",
    degree:
      "Advanced Diploma in Computer Programming and Analysis - Graduated with Honours",
    school: "George Brown Polytechnic",
    note:
      "Concentration on implementation of full-stack applications, with exposure to " +
      "dev ops, project management, and software architecture. Multiple semesters on the Dean's List.",
  },
];

export const projects = [
  {
    num: "001",
    title: "CBC BSWA",
    description:
      "Capstone project for George Brown's Computer Programming and Analysis program. A full-stack web application built with React, Node.js, and MongoDB." +
      "Created for CBC as a tool to partially automate the process of creating scheduling alignment documents for Olympic and Paralympic broadcasts.",
    tags: ["React", "Node.js", "MongoDB"],
    link: "https://github.com/theLegasea/CBC_BSWA",
    docsLink: "/docs/tideline",
  },
  {
    num: "002",
    title: "Employee Management System",
    description:
      "A backend API built with Node.js, GraphQL, and MongoDB for managing employee data. Features include CRUD operations, and user authentication.",
    tags: ["Node.JS", "MongoDB", "GraphQL"],
    link: "https://github.com/theLegasea/employee_management_system",
  },
  {
    num: "003",
    title: "Hacker News Client App",
    description:
      "A mobile app built with SwiftUI that fetches and displays top stories from the Hacker News API. Features include a story browser, reading list, and" +
      "comment viewer. Focused on clean UI and smooth performance.",
    tags: ["Swift", "SwiftUI", "IOS"],
    link: "https://github.com/alwaysandy/COMP3097Project",
  },
  {
    num: "004",
    title: "Weather Tracking App",
    description:
      "A single-page application that consumes the OpenWeatherMap API to display current weather.",
    tags: ["React", "API", "Single Page App"],
    link: "https://github.com/theLegasea/weather_app",
  },
  {
    num: "005",
    title: "Chat Application",
    description:
      "A real time chat application built with Node.js and Socket.io. Users can join topic-based chat rooms" +
      "and exchange messages in real time. Application includes simple authentication, message persistence, and typing indicators.",
    tags: ["Node.js", "React", "Socket.io"],
    link: "https://github.com/theLegasea/chat_app",
  },
];
